import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment-timezone';

const initialState = {
    timezone: moment.tz.guess(true)
};

const selectedRegion = createSlice({
    name: 'selectedRegion',
    initialState,
    reducers: {
        setRegionSelection: (state, action) => {
            state.timezone = action.payload;
        }
    }
});

if (PULSE.app.redux) {
    PULSE.app.redux.reducers.selectedRegion = {
        root: selectedRegion.reducer
    };
    PULSE.app.redux.actions = {
        ...PULSE.app.redux.actions,
        selectedRegion: selectedRegion.actions
    };
} else {
    PULSE.app.redux = {
        actions: {
            selectedRegion: selectedRegion.actions
        },
        reducers: {
            root: {
                selectedRegion: selectedRegion.reducer
            }
        }
    };
}
